import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import surface_water_overlay from '../../static/mask_surface_water.png'
import ground_water_overlay from '../../static/mask_ground_water.png'
import { OverlayImage } from './Overlay.styles'

const Overlay = ({ match }) => {
  const path = match.params.layerID
  const imageSrc =
    path && path === 'groundwater'
      ? ground_water_overlay
      : surface_water_overlay
  return <OverlayImage path={path} alt="overlay" src={imageSrc} />
}

Overlay.propTypes = {
  match: PropTypes.object
}

export default withRouter(Overlay)
